import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Admin as ReactAdmin, Resource, Layout, AppBar, CustomRoutes } from 'react-admin';
import Typography from '@mui/material/Typography';
import { createBrowserHistory } from 'history';
import { Navigate } from 'react-router-dom';
import 'normalize.css';

import axios from 'utils/axios';
import { getAdminUser } from 'utils/helpers';
import { ProfileList, ProfileShow } from 'resources/profiles';
import dataProvider from './dataProvider';
import authProvider from './authProvider';
import ResetPassword from 'components/ResetPassword';
import './App.css';

const history = createBrowserHistory();

export const useSchool = () => {
  const user = getAdminUser();
  const [school, setSchool] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    if (!user?.school_id) return;

    axios
      .get(`/v1/schools/${user.school_id}`, { signal: controller.signal })
      .then(response => setSchool(response.data))
      .catch(error => {
        if (axios.isCancel(error)) {
          console.log('Request cancelled', error.message);
        } else {
          console.error('Failed to fetch school', error);
        }
      });

    return () => {
      controller.abort(); // 🛑 Cancel axios request properly on unmount
    };
  }, [user?.school_id]);

  return school;
};

const MyAppBar = ({ school, color, ...props }) => (
  <AppBar
    sx={{
      '& .RaAppBar-title': {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      },
    }}
    {...props}
    style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
    color="primary"
  >
    <Typography variant="h6" color="inherit" id="react-admin-title">
      {school && school.name}
    </Typography>

    <div style={{ marginLeft: 'auto' }} />
  </AppBar>
);

const Menu = () => <div />;
const Sidebar = () => <div />;

const MyLayout = ({ school, ...props }) => (
  <Layout
    {...props}
    appBar={appBarProps => <MyAppBar {...appBarProps} school={school} />}
    menu={Menu}
    sidebar={Sidebar}
  />
);

const Dashboard = () => <Navigate to="/profiles" replace />;

const Admin = () => {
  const school = useSchool();

  return (
    <ReactAdmin
      dataProvider={dataProvider}
      authProvider={authProvider}
      dashboard={Dashboard}
      history={history}
      layout={props => <MyLayout {...props} school={school} />}
    >
      <CustomRoutes>
        <Route path="/reset-password/:token" element={<ResetPassword />} />
      </CustomRoutes>

      <Resource name="profiles" list={ProfileList} show={ProfileShow} />
      <Resource name="gigs" />
      <Resource name="users" />
    </ReactAdmin>
  );
};

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/*" element={<Admin />} />
    </Routes>
  </BrowserRouter>
);
export default App;
